import $ from 'jquery';
import EFOcats_event_interlock_option from '../../../core/v2/event/efocats_event_interlock_option';
import EFOcats_import_html from '../../../core/v2/import/efocats_import_html';

export default class EFOcats_curves_event_interlock_option extends EFOcats_event_interlock_option {
  updateOptions() {
    const options = $(`select[name="${this.destName}"]`).children();
    this.$(`select[name="${this.destName}"]`).empty();

    for (let index = 0; index < options.length; index++) {
      const option = options.eq(index);

      if (option.prop('tagName').toLowerCase() === 'optgroup') {
        const group = this.$(`select[name="${this.destName}"]`).append(EFOcats_import_html.getValue('select-opt-group', {label: option.attr('label')}));
        const suboptions = option.children();

        for (let subindex = 0; subindex < suboptions.length; subindex++) {
          const suboption = suboptions.eq(subindex);
          group.append(EFOcats_import_html.getValue('select-question-option', {val: suboption.val(), text: suboption.text()}));
        }
      } else {
        this.$(`select[name="${this.destName}"]`).append(EFOcats_import_html.getValue('select-question-option', {val: option.val(), text: option.text()}));

        if (option.prop('disabled')) {
          this.$(`select[name="${this.destName}"] option`).last().prop('disabled', true);
        }
      }
    }

    this.$(`select[name="${this.destName}"]`).val($(`select[name="${this.destName}"]`).val());

    efocats.validations.check_error(this.$(`select[name="${this.destName}"]`), false);
  }
}
